export default __webpack_public_path__ + "static/media/sales.48b19d43.svg";